var stopVideo = function ( element ) {
	var iframe = element.querySelector( 'iframe');
	var video = element.querySelector( 'video' );
	if ( iframe ) {
		var iframeSrc = iframe.src;
		iframe.src = iframeSrc;
	}
	if ( video ) {
		video.pause();
	}
};


jQuery(function($) {

    $(".m-News__thumbnail").on("click", function(){
        stopVideo($(this));
    });

    // submit the doctor search form when changed
    $("#doctor-search,#doctor-filter").on("change", function(e) {
        e.preventDefault();
        $(this).submit();
    });

    let buttons = document.querySelectorAll(".scheduling-button a");

    let callback = (e) => {

        e.preventDefault();
        let visitType = e.currentTarget.getAttribute('data-id')
        let npi = $("#openSchedulingFrame").data("npi");
        let deptId = $("#openSchedulingFrame").data("dept");
        $(".scheduling").hide();
        $(".schedule .selection .choice").text(e.currentTarget.innerText);

        let key = (window.location.host === 'www.theportlandclinic.com' || window.location.host === 'theportlandclinic.com') ? "nuVAqm989353691" : "OYjfTDtDcdhAed7";
        let endUrl = "https://mychart.tpcllp.com/MyChart//openscheduling/embedded?apikey="+key+"&widgetid=MyChartIframe0&dept=" + deptId + "&vt=" + visitType + "&id=" + npi;

        $("#openSchedulingFrame")[0].src = endUrl;
        $(".schedule").fadeIn("fast");
        let h = $("#openSchedulingFrame").offset().top;
        $("body,html").animate(
            {
                scrollTop: h + "px"
            },
            250
        );
    }

    buttons.forEach((button)=>{
        button.addEventListener('click', callback);
        button.addEventListener('touchend', callback)
    })

    $("#general-search").on("click", function(e) {
        // focus on search input
        setTimeout(function() {
            $("#searchForm").focus();
        }, 100);
    });

    $(window).on("load resize", function() {

        let noticeH = 0;
        let navHght = $('.c-Header__body')[0].offsetHeight;
        let navUtil = $('.c-Header__utility')[0].offsetHeight;

        // Mobile nav settings
        if ($('body').width() <= 899) { navUtil = 0; navHght = $('.c-Header__main')[0].offsetHeight; }

        // notification bar settings
        if ($("body").hasClass("with-notification")) { noticeH = $(".notification-bar")[0].offsetHeight; }

        // centennial-hero full height modification
        if ($('.centennial-hero').length) {
            $('.centennial-hero').css({
                height: 'calc(100vh - '+ (noticeH + navHght + navUtil) +'px)'
            })

        }
    });

    $(window).on("load", function() {

        // centennial-hero full height modification
        if ($('.centennial-hero').length) {

            if ($('.centennial-hero')[0].offsetHeight > 666 && $('.centennial-hero')[0].offsetWidth > 899) {
                $('.centennial-icon').css({display: 'block'});
            }
        }
    });

    $(".slider").slick({

        // normal options...
        infinite: true,
        dots: true,
        arrows: true,
        centerMode: true,
        centerPadding: '25%',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
       

        // the magic
        responsive: [{

            breakpoint: 1024,
            settings: {
                centerPadding: '0',
                slidesToShow: 1,
                variableWidth: false, 
            }

        }, {

            breakpoint: 600,
            settings: {
                centerPadding: '0',
                slidesToShow: 1, 
                variableWidth: false, 
            }

        }, {

            breakpoint: 300,
            settings: "unslick" // destroys slick

        }]
    });
});

window.addEventListener("load", function() {

    //For each individual carousel on the page, calculate each slide's text card info (.slide-info) heights and get the max height.
    var carousels = document.querySelectorAll(".slick-slider");
    for(i = 0; i < carousels.length; i++){
        var allSlides = carousels[i].querySelectorAll(".slick-slide");    
        
        var baseSlideHeight = 410;
        var viewportWidth = window.innerWidth;
        if(viewportWidth >= 768){
            baseSlideHeight = 600;
        }

        var theSlides = [];
        for(var i = 0; i < allSlides.length; i++) {
            if(allSlides[i].classList.contains("slick-cloned") === false) {
                theSlides.push(allSlides[i]);
            }
        }

        var minSlideInfoHeight = 1000;
        var maxSlideInfoHeight = 0;
        var slideInfoDivs = [];
        for(var i = 0; i < theSlides.length; i++) {
            var slideInfoHeight = 0;
            for(var j = 0; j < theSlides[i].children.length; j++){
                if(theSlides[i].children[j].classList.contains("slide-info")){
                    slideInfoDivs.push(theSlides[i].children[j]);
                    slideInfoHeight = theSlides[i].children[j].offsetHeight;
                    if(slideInfoHeight > maxSlideInfoHeight ) {
                        maxSlideInfoHeight = slideInfoHeight;
                    } 
                    if(slideInfoHeight < minSlideInfoHeight) {
                        minSlideInfoHeight = slideInfoHeight;
                    }
                }
            }
        }
        
        //Now that we have the max height, loop through all .slide-info elements and set their height to the max height.
        for(var i = 0; i < slideInfoDivs.length; i++) {
            slideInfoDivs[i].style.height = maxSlideInfoHeight + "px";
        }

        //Go through each slide, including slides with .slide-info and slides without .slide-info, and increase the slides' height.
        var diffenceInHeight = maxSlideInfoHeight - minSlideInfoHeight;
        for(var i = 0; i < theSlides.length; i++) {
            theSlides[i].style.height = baseSlideHeight + diffenceInHeight + "px";
        }
    }

}, "false");
